import { useCallback, useRef } from 'react';

export default function useCallbackRef<T>(callback: (node: T) => void) {
  const cleanupRef = useRef<Function | void>();
  const cb = useCallback(
    (node: T) => {
      if (cleanupRef.current) {
        cleanupRef.current();
        cleanupRef.current = undefined;
      }

      if (node) {
        cleanupRef.current = callback(node);
      }
    },
    [callback],
  );

  return cb;
}
